import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "active-player-area player-area-subarea" }
const _hoisted_2 = { class: "section resources" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "section construction" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "road" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "settlement" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "city" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "section development-cards" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_resource_card = _resolveComponent("resource-card")!
  const _component_popup_menu = _resolveComponent("popup-menu")!
  const _component_card_deck = _resolveComponent("card-deck")!
  const _component_development_card = _resolveComponent("development-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playerState.resources, (quantity, resource) => {
        return (_openBlock(), _createBlock(_component_card_deck, {
          key: resource,
          quantity: quantity
        }, {
          "extra-card": _withCtx(({ index }) => [
            _createVNode(_component_resource_card, {
              "no-icon": "",
              resource: resource,
              class: _normalizeClass({
              trading:
                resource === _ctx.tradingResource && index < _ctx.tradingExchangeRate,
            })
            }, null, 8, ["resource", "class"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_popup_menu, null, {
              buttons: _withCtx(() => [
                (_ctx.tradingResource === null)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.availableActions.includes('Collect'))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.collect(resource))
                          }, " + ", 8, _hoisted_3))
                        : _createCommentVNode("", true),
                      (_ctx.availableActions.includes('Discard'))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: ($event: any) => (_ctx.discard(resource))
                          }, " - ", 8, _hoisted_4))
                        : _createCommentVNode("", true),
                      (_ctx.tradableResources.includes(resource))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            onClick: ($event: any) => (_ctx.startTrading(resource))
                          }, " $- ", 8, _hoisted_5))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.tradingResource === resource)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancelTrading()))
                          }, " × "))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: ($event: any) => (_ctx.trade(resource))
                          }, "$+", 8, _hoisted_6))
                    ], 64))
              ]),
              default: _withCtx(() => [
                _createVNode(_component_resource_card, {
                  resource: resource,
                  disabled: quantity === 0,
                  class: _normalizeClass({
              trading:
                resource === _ctx.tradingResource &&
                quantity === _ctx.tradingExchangeRate,
            })
                }, null, 8, ["resource", "disabled", "class"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["quantity"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.startBuildingRoad())),
        disabled: !_ctx.availableActions.includes('BuildRoad')
      }, _hoisted_10, 8, _hoisted_8),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.startBuildingSettlement())),
        disabled: !_ctx.availableActions.includes('BuildSettlement')
      }, _hoisted_13, 8, _hoisted_11),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.startBuildingCity())),
        disabled: !_ctx.availableActions.includes('BuildCity')
      }, _hoisted_16, 8, _hoisted_14)
    ]),
    _createElementVNode("div", _hoisted_17, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playerState.allDevelopmentCards, (card) => {
        return (_openBlock(), _createBlock(_component_development_card, {
          key: card.id
        }))
      }), 128)),
      _createVNode(_component_popup_menu, {
        disabled: !_ctx.availableActions.includes('BuyDevelopmentCard')
      }, {
        buttons: _withCtx(() => [
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.buyDevelopmentCard()))
          }, "+")
        ]),
        default: _withCtx(() => [
          _createVNode(_component_development_card)
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}